export default "__VITE_ASSET__CBSC93GK__"